"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M8 0C4.96 0 2.49 2.39 2.49 5.33 2.49 8.28 8 16 8 16s5.51-7.72 5.51-10.67C13.5 2.39 11.04 0 8 0zm0 8a2.5 2.5 0 010-5 2.5 2.5 0 010 5z"];
//# sourceMappingURL=map-marker.js.map